import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/retour.png'


const _withScopeId = n => (_pushScopeId("data-v-26f0231c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "opt",
  class: "w-1/3 h-96 bg-white absolute z-40 top-1/3 left-1/3 hidden"
}
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "grid grid-cols-2 pt-16" }
const _hoisted_4 = { class: "flex flex-col items-center h-64" }
const _hoisted_5 = { class: "h-16" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Taille de la bille", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "petite" }, "Petite", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "moyenne" }, "Moyenne", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "grosse" }, "Grosse", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex flex-col items-center" }
const _hoisted_12 = { class: "h-16" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Taille de la bille", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "petite" }, "Petite", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "moyenne" }, "Moyenne", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "grosse" }, "Grosse", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "flex gap-3 justify-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-16 h-16 bg-blue-500 rounded-full",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["bg-blue-800 rounded-full", {
                'w-5 h-5': _ctx.tailleB == 'petite',
                'w-10 h-10': _ctx.tailleB == 'moyenne',
                'w-16 h-16': _ctx.tailleB == 'grosse',
              }])
              }, null, 2)
            ]),
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              name: "",
              id: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tailleB) = $event)),
              class: "w-32 p-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
            }, _hoisted_10, 512), [
              [_vModelSelect, _ctx.tailleB]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["bg-red-800 rounded-full", {
                  'w-5 h-5': _ctx.tailleR == 'petite',
                  'w-10 h-10': _ctx.tailleR == 'moyenne',
                  'w-16 h-16': _ctx.tailleR == 'grosse',
                }])
                }, null, 2)
              ]),
              _hoisted_13,
              _withDirectives(_createElementVNode("select", {
                name: "",
                id: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tailleR) = $event)),
                class: "w-32 p-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-800 focus:border-red-800"
              }, _hoisted_17, 512), [
                [_vModelSelect, _ctx.tailleR]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.changerTaille(_ctx.tailleB, _ctx.tailleR);
            _ctx.cacherCard('opt');
            _ctx.flou = false;
          }),
            class: "bg-blue-500 w-64 text-md py-2 px-3 text-white"
          }, " Changer Taille "),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => {
            _ctx.cacherCard('opt');
            _ctx.flou = false;
          }),
            class: "bg-red-500 w-64 text-md py-2 px-3 text-white"
          }, " Annuler ")
        ])
      ])
    ]),
    _createVNode(_component_Questions, {
      id: "card",
      Presentation: " Cette experience est une exploration captivante des lois fondamentales\n        qui gouvernent le mouvement des objets dans notre univers.",
      titre: "PRINCIPE FONDAMENTALE DE LA DYNAMIQUE",
      cacherCard: _ctx.cacherCard,
      questions: _ctx.questions,
      fichier: "principe_dynamique_pfd"
    }, null, 8, ["cacherCard", "questions"]),
    _createElementVNode("div", {
      class: "fixed z-40 right-2 bottom-5 w-16 h-16",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.actualiser && _ctx.actualiser(...args)))
    }, _hoisted_20),
    _createElementVNode("main", {
      class: _normalizeClass({ 'blur-sm': _ctx.flou == true })
    }, [
      _createElementVNode("div", {
        class: "absolute top-2 left-2 bg-white py-3 px-4 bg-white rounded-full flex justify-center items-center cursor-pointer",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.testfinal && _ctx.testfinal(...args)))
      }, " Fin de la simulation "),
      _createVNode(_component_LoadingScreen, { isLoaded: _ctx.loaded }, null, 8, ["isLoaded"]),
      _hoisted_21
    ], 2)
  ], 64))
}